import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Eyebrow } from '../ui/Eyebrow';
const included = [{
  label: 'Clinician review and written protocol',
  value: 'Included'
}, {
  label: 'Baseline 62-marker panel',
  value: 'Included annually'
}, {
  label: 'Medication, named pharmacy and lot',
  value: 'At published price'
}, {
  label: 'Follow-up panels and dose changes',
  value: 'Included'
}, {
  label: 'Shipping, including cold-chain',
  value: 'Free'
}];
const excluded = ['Dispensing fees added at checkout', 'Consult fees per message or per visit', 'Auto-escalating doses you did not approve', 'Annual contracts or cancellation calls', 'Overseas-sourced vials with no documentation'];
export function Transparency() {
  return <section className="bg-cream" data-id="element-117" data-mp="3i91xfy5pyiog">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-118" data-mp="3i7zc05r618fx">
        <div className="grid gap-14 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-119" data-mp="3db8sf8g5jupr">
          <div data-id="element-120" data-mp="3tttrahrpwln4">
            <Eyebrow className="text-brick" data-id="element-121" data-mp="3tubxa646me88">Transparency</Eyebrow>
            <h2 className="mt-4 font-serif text-4xl leading-[1.06] text-ink md:text-[3.25rem]" data-id="element-122" data-mp="2n98tmfqam1p">
              The price is the price.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-ink-soft" data-id="element-123" data-mp="7faegpie5eir">
              Republic separates what you pay for clinical care from what you pay for medication, and
              publishes both. Your rate is held for twelve months from the day you start.
            </p>
            <Link to="/pricing" className="mt-8 inline-flex border-b border-brick pb-1 text-sm text-brick transition-colors duration-150 ease-republic hover:border-ink hover:text-ink" data-id="element-124" data-mp="3fuu3fcc14as0">
              See full pricing
            </Link>
          </div>

          <div className="grid gap-10 md:grid-cols-2" data-id="element-125" data-mp="103eqrtvgwpuf">
            <div data-id="element-126" data-mp="104zgn66u7kly">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-127" data-mp="143ylyrwhdjdx">
                What is included
              </h3>
              <ul className="mt-5" data-id="element-128" data-mp="313ji12ou3cn4">
                {included.map(item => <li key={item.label} className="rule flex items-start gap-3 py-4" data-id="element-129" data-mp="2w6kux43l85yf">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick" strokeWidth={2} data-id="element-130" data-mp="3a62jpjgvvj7s" />
                    <div data-id="element-131" data-mp="355y3zvnsusim">
                      <p className="text-sm text-ink" data-id="element-132" data-mp="357rbtea5fis7">{item.label}</p>
                      <p className="mt-1 text-sm text-ink-muted" data-id="element-133" data-mp="2hgdip646bj66">{item.value}</p>
                    </div>
                  </li>)}
              </ul>
            </div>
            <div data-id="element-134" data-mp="2r6oluqg19oc0">
              <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-135" data-mp="2r786iex2iqtq">
                What Republic does not do
              </h3>
              <ul className="mt-5" data-id="element-136" data-mp="2mendvgpwejrs">
                {excluded.map(item => <li key={item} className="rule flex items-start gap-3 py-4" data-id="element-137" data-mp="1yp2tqui0dggx">
                    <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-stone" strokeWidth={2} data-id="element-138" data-mp="1ts2nojl5sdpt" />
                    <p className="text-sm text-ink-soft" data-id="element-139" data-mp="99085dy8slws">{item}</p>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}